import { createUsersModule } from "common/users"
import AnalyticsIcon from "components/icons/AnalyticsIcon"
import HomeIcon from "components/icons/HomeIcon"
import ShortLogoIcon from "components/icons/ShortLogo"
import { Spinner } from "flowbite-react"
import { useSelector } from "react-redux"
import ProfileMenu from "./ProfileMenu"

const Logo = () => {
    return <>
        <div className="hidden md:block">
            <svg width="114" height="27" fill="none" xmlns="http://www.w3.org/2000/svg"
                className="sc-btNvpj jsbDai"><g clipPath="url(#boast-logo_svg__clip0_236_193)"><path d="M53.88 0L42.664 26.547h4.97L58.852 0h-4.971z" fill="#32D583"></path><path d="M87.88 19.927c0 4.193-3.588 7.009-8.924 7.009a23.663 23.663 0 01-8.976-1.939l1.777-3.96a16.923 16.923 0 007.2 1.78c3.94 0 4.572-1.57 4.597-2.509.044-1.554-1.307-2.333-5.148-2.981-3.356-.57-8.428-1.421-8.428-6.504 0-4.113 3.35-6.769 8.536-6.769 2.855.055 5.68.594 8.358 1.594l-1.488 4.09a19.164 19.164 0 00-6.87-1.477c-3.6 0-4.18 1.362-4.206 2.174-.058 1.805 2.53 2.225 4.815 2.596 3.485.564 8.756 1.418 8.756 6.896m-31.512-9.34l6.744 15.961h4.97l-9.23-21.842-2.483 5.881zm-42.288 9.3c0-1.19-.66-2.607-3.799-2.607H4.443v5.28h5.995c3.009 0 3.64-1.418 3.64-2.607l.001-.066zm-9.64-6.37h4.692c3.061 0 3.705-1.385 3.705-2.545v-.065c0-1.577-1.233-2.48-3.384-2.48h-5.01v5.09H4.44zm5.744-9.076c2.476 0 4.45.671 5.708 1.94a5.006 5.006 0 011.477 3.695v.065c0 2.079-.929 3.614-2.844 4.692l-.317.18.336.131c2.848 1.098 4.064 2.702 4.064 5.357v.063c0 3.807-2.98 5.987-8.173 5.987H0V4.44h10.183zm21.741 18.226c3.864 0 6.56-2.975 6.56-7.172 0-4.197-2.693-7.172-6.56-7.172-3.866 0-6.56 2.975-6.56 7.172 0 4.197 2.694 7.172 6.56 7.172zm0-18.61a11.3 11.3 0 016.31 1.928 11.42 11.42 0 014.183 5.133c.86 2.09 1.084 4.39.646 6.608a11.463 11.463 0 01-3.108 5.856 11.332 11.332 0 01-5.815 3.13 11.283 11.283 0 01-6.562-.65 11.376 11.376 0 01-5.097-4.213 11.496 11.496 0 01-1.914-6.354c0-3.034 1.196-5.943 3.326-8.088a11.318 11.318 0 018.031-3.35zm57.474.384v4.083h7.121V26.55h4.505V8.524h7.121V4.441H89.398zM109.201 6.341c0-.41.121-.81.347-1.151a2.045 2.045 0 013.166-.314 2.079 2.079 0 01-.312 3.189 2.046 2.046 0 01-1.931.192 2.052 2.052 0 01-1.115-1.122 2.077 2.077 0 01-.155-.794zm.311 0c0 .348.102.689.294.978a1.737 1.737 0 002.688.267 1.768 1.768 0 00-.264-2.707 1.742 1.742 0 00-2.586.789 1.766 1.766 0 00-.132.673zm1.699.255h-.407v.938h-.33V5.158h.961a.718.718 0 01.706.436c.04.09.06.189.06.288a.695.695 0 01-.601.704l.631.948h-.408l-.612-.938zm-.408-1.144v.84h.63a.419.419 0 00.418-.42.419.419 0 00-.418-.42h-.63z" fill="#101828"></path></g><defs><clipPath id="boast-logo_svg__clip0_236_193"><path fill="#fff" d="M0 0h113.317v26.936H0z"></path></clipPath></defs></svg>
        </div>
        <div className="block md:hidden">
            <ShortLogoIcon />
        </div>
    </>
}
const Header: React.FC<any> = ({ }) => {
    const usersModule = createUsersModule()
    const profile = useSelector(usersModule.profileSelector)
    return <div className="flex justify-between items-center bg-white">
        <Logo />
        {/* <span className="text text-[#31D582] text-[14px] md:text-[24px] font-bold">
            {CONFIG.APP_NAME}
        </span> */}
        <div className="flex gap-2 items-center">
            <nav>
                <ul className="flex gap-1 border-r-2 border-gray-300 pe-2">
                    <li className={`flex gap-2 ${profile?.user?.is_admin ? "border-r-2 border-gray-300" : ""} pe-2`}>
                        <a href="/" className="flex gap-1">
                            <HomeIcon />
                            <span className="hidden md:inline hover:text-[#99E0C2]">Home</span>
                        </a>
                    </li>
                    {profile?.user?.is_admin && <li className="">
                        <a href="/analytics" className="flex gap-1">
                            <AnalyticsIcon />
                            <span className="hidden md:inline hover:text-[#99E0C2]">Analytics</span>
                        </a>
                    </li>}
                </ul>
            </nav>
            {profile ?
                <ProfileMenu />
                :
                <Spinner />
            }
        </div>
    </div>
}

export { Header }